import CourseActions from '../actions/courseActions';

function courseReducer(state = {
    courses: {},
    isErrorInCourses: false,

    joinCourse: {},
    isErrorInJoinCourse: false,

    isLoading : false,

    quizInfo : {},
    isErrorInQuizInfo : false,

    modules : [],
    isErrorInModules : false

}, action) {

    switch (action.type) {
        case CourseActions.courses:
            return {
                isErrorInCourses : false,
                courses : {}
            }
        case CourseActions.coursesSuccess:
            return {
                ...state,
                courses: action.data,
                isLoading : false,
                isErrorInCourses : false,
                joinCourse: {},
            };

        case CourseActions.coursesFailed:
            return {
                ...state,
                isErrorInCourses: true,
                isLoading : false,
                courses : {}
            };

        case CourseActions.joinCourse:
            return {
                ...state,
                isErrorInJoinCourse : false,
                joinCourse: {}
            };

        case CourseActions.joinCourseSuccess:
            return {
                ...state,
                joinCourse: action.data,
                isErrorInJoinCourse : false
            };

        case CourseActions.joinCourseFailed:
            return {
                ...state,
                isErrorInJoinCourse : true,
                joinCourse: {},
                isLoading : false
            };

        case CourseActions.modules:
            return {
                ...state,
                modules : [],
                isErrorInModules : false,
                courses : {}
            };

        case CourseActions.modulesSuccess:
            // let newArr = [...state.modules,action.data]
            return {
                ...state,
                // modules : newArr,
                modules : action.data,
                isLoading : false,
                isErrorInModules : false,
                quizInfo : {},
                joinCourse: {},
            };

        case CourseActions.modulesFailed:
            return {
                ...state,
                isErrorInModules : true,
                modules: [],
                isLoading : false,
                quizInfo : {}
            };

        case CourseActions.quizInfo:
            return {
                ...state,
                quizInfo : action.data
            };
            
        default:
            return state;
    }
}

export default courseReducer;


// WEBPACK FOOTER //
// ./src/store/reducer/coursereducer.js